import React from 'react';
import { Button } from '@mui/material';

interface HeaderNavButtonProps {
  url: string;
  title: string;
  onClick?: (url: string) => void;
  isActive?: boolean;
  disabled?: boolean;
}

export const HeaderNavButton = ({ url, title, disabled = false, isActive, onClick }: HeaderNavButtonProps) => {
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    onClick && onClick(url);
  };

  return (
    <Button
      onClick={onClick ? handleClick : undefined}
      href={!onClick ? url : undefined}
      disabled={disabled}
      sx={{
        paddingLeft: '16px',
        paddingRight: '16px',
        textTransform: 'capitalize',
        fontSize: '16px',
        flexShrink: 0,
        whiteSpace: 'nowrap',
        letterSpacing: '.5px',
        backgroundColor: isActive ? 'white' : '#1D2026',
        color: isActive ? '#1D2026' : 'white',
        py: 0.5,
        px: 1,
        '&:hover': {
          background: '#6C696A',
          color: 'white',
        },
        '&.MuiButton-contained': {
          color: '#1D2026',
          background: '#fff',
          boxShadow: 'none',
        },
        '&.MuiButton-root.Mui-disabled': {
          color: 'white',
          opacity: 0.5,
        },
      }}
    >
      {title}
    </Button>
  );
};
